import axios from 'axios';

import { buildApiV2Url } from '../utils/apiUtils';
import { generateApiError } from '../utils/apiErrorMessages';
import { mapSurveyFromJsonApiModel } from '../dataMapper/surveyDataMapper';
import createSurveySubmissionErrors from '../submissionErrors/createSurveySubmissionErrors';
import { SURVEY_TYPE_COLLECTION_PATH } from '../config/EntityCollectionPathMap';

const cloneSurvey = (entityId, data = {}) =>
  axios
    .post(
      buildApiV2Url(`${SURVEY_TYPE_COLLECTION_PATH}/${entityId}/clone`),
      data,
    )
    .catch(
      generateApiError({ submissionErrorMap: createSurveySubmissionErrors }),
    )
    .then(response => mapSurveyFromJsonApiModel(response.data));

export default cloneSurvey;
